module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-panel",
    attrs: {
      "id": "page__manipulator"
    }
  }, [_c('md-content', {
    attrs: {
      "md-theme": "white",
      "loading": _vm.progress
    }
  }, [_c('ManipulatorsMenu'), _vm._v(" "), _c('sort-table', {
    ref: "table",
    attrs: {
      "columns": _vm.tableColumns,
      "per-page": _vm.perPage,
      "total": _vm.pricesAmount,
      "link": "",
      "table-id": "manipulatorprice",
      "tableHeight": "calc(100% - 48px)"
    },
    on: {
      "refresh": _vm.getPrices,
      "create": _vm.addPrice
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function(scope) {
        return [_c('z-icon-button', {
          attrs: {
            "icon": ['fa', 'trash'],
            "danger-light": "",
            "rounded": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              $event.preventDefault();
              _vm.onRemove(scope.item.id)
            }
          }
        })]
      }
    }]),
    model: {
      value: (_vm.prices),
      callback: function($$v) {
        _vm.prices = $$v
      },
      expression: "prices"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e01b3ac","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/cost/views/manipulator/Manipulators.vue
// module id = 1182
// module chunks = 0